<div class="d-flex" [ngClass]="allowEditing && 'editable'">
    <div  class="title flex-1 d-flex" (click)="editAsset()">
        <h3 class="d-inline-block">{{ asset?.name }}</h3>
        <kui-icon *ngIf="allowEditing" class="edit-button flex-1 p-1 pl-2 muted"
            name="edit" size="xs"></kui-icon>
    </div>
    <div *ngIf="movement && duration"
        class="small">{{ duration.ago }}</div>
</div>

<div class="d-flex">
    <div class="mr-2"
        [innerHTML]="sanitize(getMapIcon(asset, 22))"></div>
    <div *ngIf="movement && movement.active && movement.speed > 0">
        <span class="muted">{{ 'STATUS.DETAILS.CARD.MOVING' | translate }}</span>&nbsp;<span>{{ movement.speed | units: 'speed' }}</span>
    </div>
    <div *ngIf="movement && movement.active && movement.speed === 0">
        <span class="muted">{{ 'STATUS.DETAILS.CARD.STOPPED' | translate }}</span>
    </div>
    <div *ngIf="movement && !movement.active">
        <span class="muted">{{ 'STATUS.DETAILS.CARD.PARKED' | translate }}</span>
    </div>
</div>

<div *ngIf="trip"
    class="mb-1">
    <span class="muted">{{ 'STATUS.DETAILS.CARD.FROM' | translate }}</span>&nbsp;<span>{{ trip.addressStart }}</span>
</div>

<div *ngIf="movement"
    class="mb-1">
    <span class="muted">{{ 'STATUS.DETAILS.CARD.NOW' | translate }}</span>&nbsp;<span>{{ movement.location }}</span>
</div>

<div *ngIf="duration && duration.seconds"
    class="mb-1">
    <span class="muted">{{ 'STATUS.DETAILS.CARD.DURATION' | translate }}</span>&nbsp;<span>{{ duration.seconds | formatSeconds }} ({{ 'STATUS.DETAILS.CARD.SINCE' | translate: { time: duration.since | units: { unit: 'time', variant: 'short'} } }})</span>
</div>

<div *ngIf="trip"
    class="mb-1">
    <span class="muted">{{ 'STATUS.DETAILS.CARD.DISTANCE' | translate }}</span>&nbsp;<span>{{ trip.distance | units: 'distance' }}</span>
</div>